"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CurrencyCodes = require("self-service-api/constants/CurrencyCodes");

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

var initialState = _CurrencyCodes.USD;

var ActiveCurrencyCode = function ActiveCurrencyCode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.default.ACTIVE_CURRENCY_CODE_UPDATED:
      return payload.currency;

    default:
      return state;
  }
};

var _default = ActiveCurrencyCode;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/ActiveCurrencyCode.js
// module id = 516
// module chunks = 5 6